export enum GroupPricingTypeEnum {
    DEFAULT,
    CUSTOM,
}
